import {API} from "../../Services";

async function StoreOnlineAddress() {
    let token = localStorage.getItem('token');
    return API.get(`/users/address/`, {headers: {'Authorization': `Bearer ${token}`}});
}

async function DeleteOnlineAddress(id) {
    let token = localStorage.getItem('token');
    return API.delete(`/users/address/${id}`, {headers: {'Authorization': `Bearer ${token}`}});
}

async function ChangeDefaultAddress(addressId, muid) {
    let token = localStorage.getItem('token');
    return API.put(`/shop/cart/`, {
        address: addressId,
        merchant_uid: muid

    }, {headers: {'Authorization': `Bearer ${token}`}});
}


async function ChangeDefaultMedAddress(addressId, muid,medId) {
    let token = localStorage.getItem('token');
    return API.put(`/shop/med-order/${medId}`, {
        address: addressId,
        merchant_uid: muid

    }, {headers: {'Authorization': `Bearer ${token}`}});
}

async function GetGuestBasket() {
    return new Promise((resolve, reject) => {
        let guestBasketLocal = localStorage.getItem("basket");
        console.log("ssssssss", guestBasketLocal)
        if (guestBasketLocal) {
            let parsed = JSON.parse(guestBasketLocal);
            let sim = parsed.map(g => {
                return {product:g.product, quantity: g.count}
            })

            console.log("xxxsss", sim)

            resolve({data: {items: sim}})
        } else {
            console.log("vvvv")
            resolve({data: {items: []}})
        }

    })
}


async function getCatsTreeApi(mId) {
    return API.get(`/shop/${mId}/nested-categories/`);
}


async function GetBasket() {
    console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$")
    let token = localStorage.getItem('token');

    if (!token)
        return GetGuestBasket()

    return API.get(`/shop/cart/`, {headers: {'Authorization': `Bearer ${token}`}});
}


async function AddToGuestBasket(merchantId, productId, product) {

    return new Promise((resolve, reject) => {
        let obj = {
            merchant_uid: merchantId,
            product_id: productId,
            product: product
        }
        let guestBasketLocal = localStorage.getItem("guestBasket");
        if (guestBasketLocal) {
            let guestData = JSON.parse(guestBasketLocal);
            guestData.push(obj)
            localStorage.setItem("guestBasket", JSON.stringify(guestData))
        } else {
            let guestData = [];
            guestData.push(obj)
            localStorage.setItem("guestBasket", JSON.stringify(guestData))
        }

        resolve(true)
    })

}

async function AddBasket(merchantId, productId, product) {
    let token = localStorage.getItem('token');

    if (!token)
        return true

    return API.post(`/shop/cart/`, {
        merchant_uid: merchantId,
        product_id: productId
    }, {headers: {'Authorization': `Bearer ${token}`}});
}


async function RemoveFromGuestBasket(merchantId, productId) {

    return new Promise((resolve, reject) => {

        let guestBasketLocal = localStorage.getItem("guestBasket");
        if (guestBasketLocal) {
            let guestData = JSON.parse(guestBasketLocal);
            let removeIndex = guestData.map(item => item.productId).indexOf(productId);
            let removed = ~removeIndex && guestData.splice(removeIndex, 1);
            localStorage.setItem("guestBasket", JSON.stringify(guestData))
        }

        resolve(true)
    })

}

async function RemoveBasket(merchantId, productId) {
    let token = localStorage.getItem('token');

    if (!token)
        return true

    return API.post(`/shop/cart/items/decrease/`, {
        merchant_uid: merchantId,
        product_id: productId
    }, {headers: {'Authorization': `Bearer ${token}`}});
}


export {
    StoreOnlineAddress,
    ChangeDefaultAddress,
    GetBasket,
    AddBasket,
    RemoveBasket,
    DeleteOnlineAddress,
    getCatsTreeApi,
    ChangeDefaultMedAddress
}
